/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'user': {
    width: 227,
    height: 227,
    viewBox: '0 0 227 227',
    data: '<defs/><path pid="0" id="user" class="cls-1" d="M2602.5 322.5a56.75 56.75 0 1 1 56.75-56.75 56.811 56.811 0 0 1-56.75 56.75zm0-85.125a28.375 28.375 0 1 0 28.38 28.375 28.394 28.394 0 0 0-28.38-28.375zM2716 436h-227v-14.187c0-50.121 46.67-85.125 113.5-85.125s113.5 35 113.5 85.125V436zm-196.37-28.375h165.74c-8.48-25.645-40.2-42.562-82.87-42.562s-74.39 16.917-82.87 42.562z" transform="translate(-2489 -209)"/>'
  }
})
